import { apiEndpoint, requestPayload, getKey, isFunction } from '../utils/common';

const _url = url => {
  if (url) {
    return apiEndpoint(url);
  }
  return '';
};

export function payload(url) {
  let options = {};
  options.data = requestPayload({});
  options.method = 'POST';
  options.url = _url(url);
  if (isFunction(getKey(this, 'runMiddleware'))) {
    options = this.runMiddleware(options);
  }
  return options;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Preprod-BnR/Deploy_checkoutjs/common/src/api/request.js